import { render, staticRenderFns } from "./LeaveManageAdminList.vue?vue&type=template&id=061b412d&scoped=true"
import script from "./LeaveManageAdminList.ts?vue&type=script&lang=ts&external"
export * from "./LeaveManageAdminList.ts?vue&type=script&lang=ts&external"
import style0 from "./LeaveManageAdminList.vue?vue&type=style&index=0&id=061b412d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b412d",
  null
  
)

export default component.exports